import React, {Fragment} from 'react';
import {bindActionCreators} from "redux";
import {connect} from 'react-redux';
import {Button} from "../components/Button";
import Title from "../components/Title";
import {config} from "../../config";
import Helmet from "react-helmet";
import createLink from "../../libs/createLink";
import {Link} from "react-router-dom";
import {resetPassword} from "../../creators/user.forgotPassword";
import queryString from "querystring";
import PasswordStrength from "../components/PasswordStrength";
import classNames from "classnames";
import passwordStrength from "../../libs/passwordStrength";


class ResetPasswordPage extends React.Component {
    constructor(props) {
        super(props);
        let search = this.props.location.search.replace("?","");
        this.actionToken = queryString.parse(search).actionToken;
        this.state = {
            password: "",
            passwordStrengthError:false,
            passwordConfirm: ""
        }
        if(!this.actionToken){
            // this.props.history.push("/");
        }
        this.onSubmit = this.onSubmit.bind(this);
    }


    onSubmit(event){
        event.preventDefault();
        event.stopPropagation();
        let password = this.state.password;
        this.props.resetPassword({actionToken : this.actionToken, password : password});
        this.setState({password : "", passwordConfirm : ""});
    }

    handlePasswordValidation(e){
        let password = e.target.value;
        let passwordStrengthError = !!password ? !passwordStrength(password).isValid : false;
        this.setState({password, passwordStrengthError});
    }

    render() {
        return (
            <div id="reset-password">
                <Helmet>
                    <title>{config.preTitle}Nouveau mot de passe{config.postTitle}</title>
                </Helmet>
                <div className="container">
                    <div className="card">
                        <div className="main-wrapper">
                            {!this.props.userForgotPasswordInitialized
                                ? (
                                <Fragment>
                                    <Title heading={"heading-1"} display={"display-2"}>Nouveau mot de passe</Title>
                                    <form className="form-forgot-password" onSubmit={(event) =>this.onSubmit(event)}>
                                        <div className={"input-group"}>
                                            <label>Entrer un nouveau mot de passe</label>
                                            <input type="password" className={classNames({error:this.state.passwordStrengthError})} placeholder="Nouveau mot de passe" value={this.state.password} onChange={this.handlePasswordValidation.bind(this)} />
                                        </div>
                                        {!!this.state.password && <PasswordStrength password={this.state.password}/>}
                                        <div className={"input-group"}>
                                            <label>Confirmer le mot de passe</label>
                                            <input type="password" placeholder="Nouveau mot de passe" value={this.state.passwordConfirm} onChange={(e) => this.setState({passwordConfirm : e.target.value})}/>
                                            {this.state.password !== this.state.passwordConfirm && this.state.passwordConfirm && (<div className="text">
                                                <p className={"color-danger"}>Les deux mots de passe doivent être identiques</p>
                                            </div>)}
                                        </div>
                                        {this.actionToken && this.props.userForgotPasswordError.error && (
                                            <div className="text">
                                                <p className={"color-danger"}>{this.props.userForgotPasswordError.message ? this.props.userForgotPasswordError.message : "Votre code de validation est incorrecte "}</p>
                                            </div>
                                        )}
                                        <Button className={"full"}
                                                btnType={"submit"}
                                                disabled={!(this.state.password && this.state.passwordConfirm && this.state.password === this.state.passwordConfirm && !this.state.passwordStrengthError)}
                                            // onClick={()=>this.onSubmit()}
                                                size={"medium"}
                                                btnStyle={"primary-reverse"}
                                                content={"Envoyer"}/>
                                    </form>
                                </Fragment>
                            )
                                : (
                                    <Fragment>
                                        <Title heading={"heading-1"} display={"display-2"}>Changement de mot de passe réussi</Title>
                                        <div>
                                            <Button
                                                className={"full"}
                                                size={"medium"}
                                                content={"Me connecter"}
                                                btnStyle={"primary-reverse"}
                                                to={createLink("signin")}
                                            />
                                        </div>
                                    </Fragment>
                                )}


                            <div className="text">
                                <p>Si vous avez le moindre problème n’hésitez pas à nous <Link to={createLink("contact")}>contacter</Link></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    userForgotPassword: state.userForgotPassword.data,
    userForgotPasswordError: state.userForgotPassword.error,
    userForgotPasswordInitialized: state.userForgotPassword.initialized
});


const mapDispatchToProps = (dispatch) => bindActionCreators({
    resetPassword
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ResetPasswordPage);

